<template>
  <TransitionGroup
    tag="div"
    class="ic-twitch-chat"
  >
    <div
      v-for="(message) in messages"
      :key="message.id"
      class="ic-twitch-chat-message"
    >
      <span class="ic-twitch-chat-message-username">
        {{ message.username }}:
      </span>
      <span class="ic-twitch-chat-message-text">
        {{ message.text }}
      </span>
    </div>
  </TransitionGroup>
</template>
<script setup lang="ts">
import { TwitchMessagesRow } from '../../../common/src/Types'

defineProps<{
  messages: TwitchMessagesRow[]
}>()
</script>
<style lang="scss">
.ic-twitch-chat {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 7px;

  position: absolute;
  width: 453px;
  height: 322px;
  left: 312px;
  top: 518px;
  max-height: 600px;
  overflow: hidden;

  -webkit-mask-image: linear-gradient(0deg, rgba(0 0 0 / 0%) 0%, rgba(0 0 0 / 100%) 30%);

  filter: drop-shadow(0px 2px 2px rgba(0 0 0 / 60%));
}

.ic-twitch-chat-message {
  font-family: 'Roboto Condensed';
  font-size: 24px;
  line-height: 28px;
  color: rgba(255 255 255 / 85%);

  filter: drop-shadow(0px 0 2px rgba(81 58 65 / 88%));

  .ic-twitch-chat-message-username {
    font-weight: bold;
  }

  .ic-twitch-chat-message-text {
    font-weight: normal;
  }
}
</style>
